import { deepFreeze } from '../../utils/misc_utils';

export const AdvertisementStatusEnum = deepFreeze({
    ACTIVE: 'ACTIVE',
    TO_ACTIVATE: 'TO_ACTIVATE'
});

export const AdvertisementFileTypeEnum = deepFreeze({
    IMAGE: 'IMAGE',
    VIDEO: 'VIDEO'
});
